// @givmo/passkeys — the "Sign in with a passkey" button (AS-WEB2's, lifted from `apps/admin` by
// AS-WEB12 so the charity console's director door shows the same one).
//
// Same chrome as the Google/Microsoft buttons (`ProviderButton` in `@givmo/design-system`), so they
// sit as one stack; only the icon and label differ. Rendering is decided by the caller
// (`usePasskeySignInAvailability`), not here: this component is presentational, exactly like
// `ProviderButton`.
//
// The copy makes no security claim. "Sign in with a passkey" names the method and nothing else: what
// the ceremony actually proves is decided by the authenticator and the backend, so any adjective here
// would be a promise this surface cannot keep.
//
// ⚠ A SIGN-IN, NEVER A STEP-UP. A door wires it to the UNBOUND passkey sign-in, which signs in
// whichever account asserts. A "Confirm it's you" sheet never holds it: the sheet's passkey arm is
// the account-bound re-confirmation (`passkeyStepUpSlot`), and `@givmo/auth`'s slot rail refuses a
// slot filler that names this button.

import { Button, Icon } from '@givmo/design-system';
import { Fingerprint } from 'lucide-react';

export interface PasskeySignInButtonProps {
  loading?: boolean;
  disabled?: boolean;
  onClick: () => void;
  /** `login-passkey-button` on every door unless a page needs two, so one e2e selector drives them. */
  testId?: string;
}

export function PasskeySignInButton({
  loading = false,
  disabled = false,
  onClick,
  testId = 'login-passkey-button',
}: PasskeySignInButtonProps) {
  return (
    <Button
      appearance="saas"
      tone="secondary"
      size="lg"
      fullWidth
      loading={loading}
      disabled={disabled}
      onClick={onClick}
      leadingIcon={<Icon icon={Fingerprint} size={18} aria-hidden />}
      className="justify-center gap-10 font-w600"
      testId={testId}
    >
      Sign in with a passkey
    </Button>
  );
}
